import Request from './request';
import { getHeaders } from './requestHelpers';

const Paths = {
  USER_LOGIN: 'login',
  USER_LOGOUT: 'logout',
  USER_ASK_RESET: 'askResetPassword',
  USER_RESET: 'resetPassword',
};

/**
 * @param {Object} params
 * @param {String} params.email - user e-mail address
 * @param {String} params.password - user password
 * @param {String} params.captchaToken - captchaToken (optional)
 * @return {Promise}
 */
export async function login(params) {
  const { status, error } = await Request({
    method: 'POST',
    data: params,
    path: Paths.USER_LOGIN,
  });

  return status ? Promise.resolve() : Promise.reject(error);
}

/**
 * @param {Object} params
 * @param {String} params.authToken - user security token
 * @return {Promise}
 */
export async function logout({ authToken }) {
  const { status, error } = await Request({
    method: 'POST',
    headers: getHeaders(authToken),
    path: Paths.USER_LOGOUT,
  });

  return status ? Promise.resolve() : Promise.reject(error);
}

/**
 * @param {Object} params
 * @param {String} params.email - user email
 * @return {Promise}
 */
export async function askResetUserPassword(params) {
  const { status, result, error } = await Request({
    method: 'POST',
    data: params,
    path: Paths.USER_ASK_RESET,
  });
  return status ? Promise.resolve(result) : Promise.reject(error);
}

/**
 * @param {Object} params
 * @param {String} params.email - user email
 * @param {String} params.emailConfirm - user email Confirm
 * @param {String} params.idHash - Received by email generated by askResetPassword
 * @param {String} params.password - Received by email generated by askResetPassword
 * @param {String} params.password - New password
 * @param {String} params.passwordConfirm - New password Confirm
 * @return {Promise}
 */
export async function resetUserPassword(params) {
  const { status, result, error } = await Request({
    method: 'POST',
    data: params,
    path: Paths.USER_RESET,
  });
  return status ? Promise.resolve(result) : Promise.reject(error);
}
